import React, { useState } from "react";
import HoverIconButton from "components/HoverIconButton";
import FieldGroupComponent from "./FieldGroupComponent";
import { STATUS } from "utils/constants/ui";
import { getFieldDeleteItemName } from "utils/builder";
import Modal from "components/Modal";
import ModalActions from "components/ModalActions";
import ModalContent from "components/ModalContent";
import { useFormikContext } from "formik";
import Pill from "components/Pill";
import startCase from "lodash/startCase";
import { isActionSchema } from "utils/schema";
import Tabs, { MINI_TABS_PROPS } from "components/Tabs";
import FieldGroupUI from "./FieldGroupUI";
import classnames from "classnames";

const CONFIRM_FIELDS = ["section"];

const DEFAULT_CLASSES = {
  container: "flex flex-column w-100 pa3 ba br2 hairline-1 relative"
};

const FieldGroupContent = ({
  index,
  name,
  arrayHelpers,
  variableContext,
  dependencies,
  schema,
  customClasses
}) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  const { setFieldTouched } = useFormikContext();
  const elName = `${name}[${index}]`;
  const [showModal, setShowModal] = useState(false);
  const item = getFieldDeleteItemName(name);

  const tooltip = `Delete ${item}`;
  const remove = () => {
    setFieldTouched(name, true);
    arrayHelpers.remove(index);
  };
  const requiresConfirmation = CONFIRM_FIELDS.indexOf(item) > -1;
  const deleteTrigger = requiresConfirmation
    ? () => setShowModal(true)
    : remove;

  const fieldProps = {
    dependencies: dependencies,
    schema: schema,
    rootName: name,
    name: elName,
    variableContext
  };

  let content = <FieldGroupComponent {...fieldProps} />;
  const hasSubMenus = isActionSchema(schema);
  if (hasSubMenus) {
    classes.container = "flex flex-column w-100 pa0 ba br2 hairline-1 relative";

    const tabProps = {
      ...MINI_TABS_PROPS,
      tabs: [
        {
          name: "Field",
          id: "field",
          node: (
            <div className="pa3 mt2">
              <FieldGroupComponent {...fieldProps} />
            </div>
          )
        },
        {
          name: "UI",
          id: "ui",
          node: (
            <div className="pa3">
              <FieldGroupUI {...fieldProps} />
            </div>
          )
        }
      ]
    };
    content = <Tabs {...tabProps} />;
  }

  return (
    <div className={classes.container}>
      <div className="absolute" style={{ top: -22, left: 8 }}>
        <Pill
          copy={`${startCase(item)} ${index + 1}`}
          customClasses={{
            copy: "f7 pa1 br2 fw5 flex-shrink-0 items-center"
          }}
          status={STATUS.NEUTRAL}
        />
      </div>
      <div
        className={classnames("", {
          "pt3 mt2": hasSubMenus
        })}
      >
        {content}
      </div>
      <div
        className={classnames("self-end", {
          "ph3 pb3": hasSubMenus,
          "pt3": !hasSubMenus
        })}
      >
        <HoverIconButton
          type="delete"
          tooltip={tooltip}
          onClick={deleteTrigger}
        />
      </div>
      {showModal && (
        <Modal showModal={showModal} onClose={() => setShowModal(false)}>
          <ModalContent
            slides={[
              {
                title: `Remove ${item}`,
                header: `Are you sure you want to remove this ${item}?`
              }
            ]}
          >
            <ModalActions
              actions={[
                {
                  cta: "Cancel",
                  onClick: () => {
                    setShowModal(false);
                  }
                },
                {
                  cta: "Confirm",
                  onClick: () => {
                    remove();
                    setShowModal(false);
                  }
                }
              ]}
            />
          </ModalContent>
        </Modal>
      )}
    </div>
  );
};

export default FieldGroupContent;
